<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="ask-expert-ai">
    <div class="ask-expert-ai__title">
      <img class="ask-expert-ai__icon"
           :src="aiSparkIcon"
           alt=""
           aria-hidden="true">
      <span v-html="$t('HEADER.ASK_IN_EXPERT_AI')" />
    </div>
    <div class="ask-expert-ai__buttons" role="group" aria-label="Ask Expert AI suggestions">
      <button v-for="(item, index) in suggestions"
              :id="`ac-ask-expert-ai-${index}`"
              :key="item.uniqueId || `${item.label}-${index}`"
              type="button"
              class="ask-expert-ai__button"
              :class="{ active: index === activeIndex }"
              :title="item.label"
              @mousedown.prevent
              @keydown.enter.prevent="onSuggestionAction($event, item)"
              @click="onSuggestionAction($event, item)">
        <img class="ask-expert-ai__icon"
             :src="aiSparkIcon"
             alt=""
             aria-hidden="true">
        {{ item.label }}
      </button>
    </div>
  </div>
</template>

<script>
import useExpertAiAction from '_acaSrc/composables/useExpertAiAction.composable';
import aiSparkIcon from '~_acaAssets/utd-ai/utd-ai-spark.svg';

export default {
    props: {
        suggestions: {
            type: Array,
            default() {
                return [];
            }
        },
        activeIndex: {
            type: Number,
            default: -1
        }
    },
    setup() {
        const { handleExpertAiAction } = useExpertAiAction();
        const onSuggestionAction = async(evt, item) => {
            const prompt = (item.label || '').trim();
            if (!prompt) {
                return;
            }
            await handleExpertAiAction({
                event: evt,
                prompt,
                queryParam: 'prompt',
                uiElementName: 'search-autocomplete-ask-expert-ai'
            });
        };
        return {
            onSuggestionAction
        };
    },
    data() {
        return {
            aiSparkIcon
        };
    }
};
</script>

<style lang="less" scoped>
  @import (reference) '~_acaAssets/wkce/colors/wkce-app-styles';
  @import (reference) '~_acaAssets/global/global.less';

  .ask-expert-ai {
      .ds1-ph-2();
      .ds1-pv-2();
      background-color: @WKCE-CREAM-TINT2;
    }

    .ask-expert-ai__title {
      .ds1-utd-size-3();
      .ds1-utd-weight-normal();
      .ds1-mb-2();
      color: @DS1-UTD-TOPIC-TEXT-COLOR;
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .ask-expert-ai__icon {
      width: 16px;
      height: 16px;
      object-fit: contain;
    }

    .ask-expert-ai__title .ask-expert-ai__icon {
      width: 24px;
      height: 24px;
      aspect-ratio: 1/1;
    }

    .ask-expert-ai__buttons {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      overflow: hidden;
      max-height: 90px;
      padding: 2px;
    }

    .ask-expert-ai__button {
      .ds1-utd-size-2();
      .ds1-utd-weight-500();
      display: flex;
      align-items: center;
      gap: 8px;
      max-width: 100%;
      border-radius: 99px;
      /* stylelint-disable-next-line declaration-property-value-no-unknown */
      border: 1px solid @WKCE-CREAM-TINT1;
      background-color: @WKCE-WHITE;
      color: @DS1-UTD-TOPIC-TEXT-COLOR;
      padding: 8px 10px;
      line-height: 18px;
      height: 40px;
      cursor: pointer;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      outline: none;
      transition: background-color .12s ease, border-color .12s ease, box-shadow .12s ease;

      &:hover {
        background-color: @WKCE-CREAM-TINT1;
        border-color: @WKCE-CREAM-TINT1;
      }

      &:focus-visible {
        background-color: @WKCE-WHITE;
        border-color: @WKCE-BLACK;
        /* stylelint-disable-next-line declaration-property-value-no-unknown */
        box-shadow: 0 0 0 2px @WKCE-BLACK;
      }

      &:active {
        background-color: @WKCE-CREAM-TINT2;
        border-color: @WKCE-CREAM-TINT2;
        box-shadow: none;
      }

      &.active {
        background-color: @DS1-UTD-AUTOCOMPLETE-ACTIVE-BG-COLOR;
        border-color: @WKCE-BLACK;
      }
    }

  @media (min-width: 768px) {
    .ask-expert-ai__button {
      height: 32px;
    }

    .ask-expert-ai__buttons {
      max-height: 72px;
    }
  }
</style>
